import React from "react";

import RotatingEmptyState from "../../../shared/EmptyState/RotatingEmptyState";

function NotFoundContent({ title }) {
  return (
    <div>
      {title && <h4 className="error">{title}</h4>}
      <RotatingEmptyState />
    </div>
  );
}

export default NotFoundContent;
